import AppBridge from './AppBridge'; // Adjust path if needed

// Keep track of last time a message was sent
let lastSentTime = 0;

// Connect to device
export const connectBluetoothDevice = async () => {
  try {
    const device = await navigator.bluetooth.requestDevice({
      filters: [{ name: 'bt05' }],
      optionalServices: ['0000ffe0-0000-1000-8000-00805f9b34fb'],
    });
    const server = await device.gatt.connect();
    console.log('Connected to Bluetooth device:', device.name);
    return { success: true, device };
  } catch (error) {
    console.error('Error connecting to Bluetooth device:', error);
    return { success: false, message: `Connection failed: ${error.message}` };
  }
};

// Send only raw message, always appending newline
export const sendBluetoothData = async (
  device,
  rawMessage,
  isMobile = false,
  onReceive
) => {
  const now = Date.now();

  // ✅ Enforce 1 second cooldown
  if (now - lastSentTime < 1000) {
    console.log('Skipping send: 1 second cooldown still active');
    return {
      success: false,
      message: 'Cooldown: wait before sending another message',
    };
  }
  lastSentTime = now;

  const messageToSend = rawMessage.endsWith('\n')
    ? rawMessage
    : rawMessage + '\n';

  if (isMobile) {
    AppBridge.sendMessage('bluetooth_write', { data: messageToSend });
    return { success: true, message: messageToSend };
  }

  if (!device || !device.gatt || !device.gatt.connected) {
    return { success: false, message: 'Bluetooth device not connected' };
  }

  try {
    const service = await device.gatt.getPrimaryService(
      '0000ffe0-0000-1000-8000-00805f9b34fb'
    );
    const characteristic = await service.getCharacteristic(
      '0000ffe1-0000-1000-8000-00805f9b34fb'
    );

    if (!characteristic._listenerAdded) {
      await characteristic.startNotifications();
      characteristic.addEventListener('characteristicvaluechanged', (event) => {
        const value = new TextDecoder().decode(event.target.value);
        console.log('Received from Arduino:', value);
        if (onReceive) {
          onReceive(value);
        }
      });
      characteristic._listenerAdded = true; // mark it so you don’t re-add
    }

    const encoder = new TextEncoder();
    console.log('Sending:', messageToSend);
    await characteristic.writeValue(encoder.encode(messageToSend));

    return { success: true, message: messageToSend };
  } catch (error) {
    console.error('Error sending Bluetooth data:', error);
    return { success: false, message: `Error: ${error.message}` };
  }
};
